

export const prepareCoolOffDto = (dto) => {
    return dto.map(item => ({
        "coolOffId": item?.coolOffId,
        "timestamp": Number(item?.timestamp)
    }))
};
